import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/aiservices";

/** AI Services page — aiservices.bizlem.com */
export default function AiServicesPage() {
  return <SubdomainSite config={config} />;
}

export { config };
